import React, { useState } from "react";
import TemplateLibrary from "./TemplateLibrary";
import { useNavigate } from "react-router-dom";
import GlobalButton from "../../../../shared/utils/GlobalButton";

const options = [
  {
    id: 1,
    title: "Premade Questionnaire",
    description:
      "Want to master Webflow’s essentials? Download our free eBook today.",
    icon: "/assests/AdminDashboard/pdi1.png",
  },
  {
    id: 2,
    title: "Start From Scratch",
    description:
      "Want to master Webflow’s essentials? Download our free eBook today.",
    icon: "/assests/AdminDashboard/pdi2.png",
  },
];

const QuestionnaireSelection = ({ onClose, campaign }) => {
  const navigate = useNavigate();

  const [showTemplateLibrary, setShowTemplateLibrary] = useState(false);

  const handleSelect = (id) => {
    if (id === 1) {
      setShowTemplateLibrary(true);
    } else {
      onClose(); // ✅ close modal first
      navigate("/adminportal/pdieditabletable", { state: { campaign } });
    }
  };

  return (
    <>
      {/* Trigger Button */}
      {/* <div className="flex justify-center my-6">
        <button
          onClick={() => setOpen(true)}
          className="px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-lg font-semibold shadow-md hover:shadow-lg transition-all"
        >
          Open Questionnaire Modal
        </button>
      </div> */}

      {/* Questionnaire Selection Modal */}
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white rounded-3xl p-8 w-[90%] max-w-4xl shadow-xl relative">
          <button
            onClick={onClose}
            className="absolute top-3 right-4 text-gray-500 hover:text-gray-700 text-2xl"
          >
            &times;
          </button>

          <h2 className="text-2xl font-bold text-center mb-8">
            Choose an Option
          </h2>

          <div className="flex flex-wrap justify-center gap-8">
            {options.map((item) => (
              <div
                key={item.id}
                onClick={() => handleSelect(item.id)}
                className="w-72 p-8 bg-white rounded-3xl shadow-[0_10px_40px_rgba(0,0,0,0.05)] text-center transition-all hover:scale-105 hover:shadow-[0_15px_50px_rgba(0,0,0,0.08)] cursor-pointer"
              >
                <div className="flex justify-center mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-md flex items-end justify-center">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="w-10 h-10 object-contain"
                    />
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-500 text-sm mb-6 leading-relaxed">
                  {item.description}
                </p>
                <GlobalButton
                  variant="primary"
                  size="large"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelect(item.id);
                  }}
                >
                  {`Select`}
                </GlobalButton>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Template Library Modal */}
      {showTemplateLibrary && (
        <TemplateLibrary onClose={() => setShowTemplateLibrary(false)} />
      )}
    </>
  );
};

export default QuestionnaireSelection;
